export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";